import React from 'react';

import CoreMap from '@vg/map-mapbox';

import { config } from '../../config';

const MapMapbox = (props) => <CoreMap {...props} accessToken={config.mapboxAccessToken} />;

export default MapMapbox;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/MapMapbox.js
 **/